<template>
  <v-app id="signup">
    <div style="position: absolute; left: 0; width: 100%; height: 100%;">
      <!--
      <vue-particles
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    >
    </vue-particles>
  -->
    </div>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md4>
            <a href="http://taybull.com">
              <img alt="Taybull Logo" width="350" src="../assets/logo-white-bg.svg"><br />
            </a>
            <form id="sign-up-form" @submit.prevent="submit()">
            <v-card class="elevation-12">

              <!--
              <v-toolbar dark color="primary">
                <v-toolbar-title>Sign up for free</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              Please enter all rquired fields and try. Passwords must match
            -->
              <v-card-text>
                <v-text-field prepend-icon="email" v-model="fullname" name="fullname"
    v-validate="'required'"
    :error-messages="errors.collect('fullname')"
    label="Full Name"></v-text-field>

                  <v-text-field prepend-icon="username" v-model="username" name="username"
      v-validate="'required|email'"
      :error-messages="errors.collect('username')"
      label="E-mail"></v-text-field>
                  <v-text-field id="password" v-model="password"  name="password" :error-messages="errors.collect('password')" prepend-icon="lock"  label="Password" type="password" v-validate="'required|min:8'" ref="password"></v-text-field>
                  <v-text-field id="password2" v-model="password2" name="password2" :error-messages="errors.collect('password2')" prepend-icon="lock" label="Confirm Password" type="password" v-validate="'required'" data-vv-as="password"></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" form="sign-up-form">Sign Up</v-btn>
              </v-card-actions>

            </v-card>
            </form>
            <p class="text-md-center">
              <br />
              <br />
              Already have an account? <router-link :to="{name: 'signin'}"> Sign in </router-link>
              <br />
              <br />
              <br />
              <br />
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('users');

  export default {
    data: () => ({
      drawer: null,
      fullname: '',
      username: '',
      password: '',
      password2: '',
      errorMessage: null,
    }),
    props: {
      source: String
    },
    methods: {
      ...mapActions(['aSignUp', 'aSignIn']),
      submit() {
        const payload = {
          fullname: this.fullname,
          username: this.username,
          password: this.password
        };

        this.errorMessage = null;
        if(payload.password != this.password2) {
          this.errorMessage = "Passwords do not match";
          return false;
        }
        let signUp = this.signUp;
        this.$validator.validateAll().then(function(response) {
          if(response === true) { signUp(payload); }
        }).catch(function(e) {});
      },
      signIn(payload) {
        let progress = this.$Progress;
        let router = this.$router;
        const signIn = this.aSignIn;
        progress.start();
        signIn(payload).then(function(response) {
          progress.finish();
          router.push({name: 'home'});
        }).catch(function(e) { progress.finish(); });
      },
      signUp(payload) {
        console.log("sign up" + payload);
        const signUp = this.aSignUp;
        const signIn = this.signIn;
        let progress = this.$Progress;
        progress.start();
        signUp(payload).then(function(response) {

          progress.finish();
          signIn(payload);
        }).catch(function(e) {
          progress.finish();
        });
      }
    },
    mounted() {
      // this.$validator.localize('en', this.dictionary);
    }
  }
</script>
